import { render } from "./AddHistory.vue?vue&type=template&id=8d072856"
import script from "./AddHistory.vue?vue&type=script&lang=js"
export * from "./AddHistory.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__